import { render, staticRenderFns } from "./LogoBigIcon.vue?vue&type=template&id=dc7abffc"
import script from "./LogoBigIcon.vue?vue&type=script&lang=js"
export * from "./LogoBigIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports